export default "__VITE_PUBLIC_ASSET__40c156d8__"